// import React, { useState } from "react";
// import { useAppContext } from "../../Universal/API/Context-API/AppContext";
// import { Pressable, VStack, Text, Box, View } from "native-base";
// import { webFont } from "../../Universal/API/API";
// import { AutoWidthImage } from "../../Universal/Image/AutoWidthImage";
// import { DeanteData } from "../../Universal/API/Context-API/AppProvider";
// import { ViewStyle } from "react-native";
// import OstatkiDisplay from "../../UnitFull/OstatkiDisplay/OstatkiDisplay";
// import CarouselImages from "../../Universal/CarouselImages/CarouselImages";
// import { TCarouselProps } from "react-native-reanimated-carousel";
// import { useUserState } from "../../Universal/API/Context-API/hooks/useUserState";

// export const shadowPropsUnit: ViewStyle = {
//     shadowColor: 'black',
//     shadowOffset: { height: 1 / 2, width: 5 / 3 },
//     shadowOpacity: 0.3,
//     shadowRadius: 14
// };
// export interface UnitProps {
//     unit: {
//         url: string;
//         description: string;
//         price: string | number;
//         unit: DeanteData;
//         discount: number,
//         discounted_price: string | number;
//     };
//     onPress?: () => any;
//     fullWidth?: boolean; // <--- добавили
// }

// export const formPrice = ({unit, isDiscount}: {unit: UnitProps['unit'], isDiscount?: boolean}) => {

//     const key = isDiscount ? 'discounted_price' : 'price';

//     return  <>{unit[key] && parseInt(unit[key] + '') > 999997 ? 'По запросу' : unit[key]}</>
// }

// export const getWidth_ = ({isSmallVersion, isMediumVersion}) => {
//         if (isSmallVersion) return '50%';
//         if (isMediumVersion) return '33.3%';
//         return '25%';
//     };

// const Unit: React.FC<UnitProps> = ({ unit, onPress, fullWidth}) => {
//     const { isSmallVersion, isTooSmall, isMediumVersion, scaleAll, showDiscountedPrices, USER } = useAppContext();
//     const [isOnHover, setIsOnHover] = useState(false);

//     const getWidth = () => {
//     if (fullWidth) return "100%";          // <--- если из сетки FlashList
//     if (isSmallVersion) return "50%";
//     if (isMediumVersion) return "33.3%";
//     return "25%";
//   };

//     const [loaded, setLoaded] = useState(false)


//     const userState = useUserState()
    

//     return (
//         <Pressable
//             width={getWidth()}
//             onPress={onPress}
//             onHoverIn={() => setIsOnHover(true)}
//             onHoverOut={() => setIsOnHover(false)}
//         >

//             <Box
//                 bg="white"
//                 width="100%"
//                 height={isSmallVersion ? 220 * scaleAll : isMediumVersion ? 320 * scaleAll : 400 * scaleAll}
//                 px={isSmallVersion ? 2 : isMediumVersion ? 5 : 8}
//                 py={isSmallVersion ? 3 : isMediumVersion ? 6 : 8}
//                 borderWidth={0.5}
//                 borderColor="gray.300"
//                 // shadow={isOnHover ? 7 : 0}
//                 style={[isOnHover ? shadowPropsUnit : {}]}
//                 alignItems="center"
//                 justifyContent="center"
//             >
//                 <View style={{ width: '100%', overflow: 'hidden', }}>
//                     {
//                         unit.unit.sliders.medium.length > 0 ?
//                             <View style={{ width: '100%', justifyContent: 'center', alignItems: 'center' }} >
//                                 <CarouselImages
//                                     carouselProps = {{loop: true,
//                                         // autoPlay: true,
//                                         // autoPlayInterval: 3000
//                                      } as TCarouselProps}
//                                     data={unit.unit.sliders.medium}
//                                     // addButtons={true}
//                                     width={300}
//                                     height={(isSmallVersion ? 80 : isMediumVersion ? 140 : 193) * scaleAll}
//                                     addPagination={true}
//                                     renderItem={
//                                         ({ item, index }) => {
//                                             return (
//                                                 <View style={{}} >
//                                                     <AutoWidthImage
//                                                         source={{
//                                                             uri: item,
//                                                             // priority:item

//                                                         }}
                                                        
//                                                         maxWidth={300}
//                                                         onLoad={() => { setLoaded(true) }}
//                                                         scaleAll={scaleAll}
//                                                         height={(isSmallVersion ? 80 : isMediumVersion ? 140 : 193) * scaleAll}
//                                                     />
//                                                 </View>
//                                             )
//                                         }
//                                     }
//                                 />




//                             </View> :
//                             <AutoWidthImage
//                                 source={{
//                                     uri: unit.url,
//                                     priority: 'high'

//                                 }}
//                                 scaleAll={scaleAll}
//                                 height={(isSmallVersion ? 90 : isMediumVersion ? 140 : 193) * scaleAll}
//                             />
//                     }
//                 </View>
//                 <VStack flex={1} justifyContent="space-between" alignItems="center" mt={4}>
//                     <Text
//                         textAlign="center"
//                         fontFamily={webFont('Inter')}
//                         fontWeight="600"
//                         maxWidth={'2/3'}
//                         fontSize={(isSmallVersion ? 12 : isMediumVersion ? 14 : 16) * scaleAll}
//                         color="black"
//                         noOfLines={3}
//                     >
//                         {unit.description}
//                     </Text>
//                     <Box style={{ width: '100%', }}>
//                         <Text
//                             textAlign="center"
//                             fontFamily={webFont('Inter')}
//                             fontWeight="600"
//                             fontSize={(isSmallVersion ? 12 : isMediumVersion ? 14 : 16) * scaleAll}
//                             color="black"
//                             mt={2}
//                         >
//                             {formPrice({unit, isDiscount: userState.isUserLoogedInAndShowDiscountPrices})}
//                         </Text>

//                     </Box>
//                 </VStack>
//             </Box>
//             <Box style={[{ position: 'absolute', zIndex: 1000, right: 10, bottom: 10 }, isTooSmall && {
//                 bottom: undefined,
//                 top: 10,
//                 // transform: [{scale: 0.8}, {translateY: -25},  {translateX: 15}]
//             }]}>
//                 <OstatkiDisplay compact={true} unit={unit.unit} scaleAll={scaleAll} ostatki={unit['unit']['ostatki']} />
//             </Box>
//         </Pressable>
//     );
// };

// export default Unit;


import React, { useEffect, useRef, useState } from "react";
import { useAppContext } from "../../Universal/API/Context-API/AppContext";
import { Pressable, VStack, Text, Box, View } from "native-base";
import { webFont } from "../../Universal/API/API";
import { AutoWidthImage } from "../../Universal/Image/AutoWidthImage";
import { DeanteData } from "../../Universal/API/Context-API/AppProvider";
import { Platform, ViewStyle } from "react-native";
import OstatkiDisplay from "../../UnitFull/OstatkiDisplay/OstatkiDisplay";
import CarouselImages from "../../Universal/CarouselImages/CarouselImages";
import { TCarouselProps } from "react-native-reanimated-carousel";
import { useUserState } from "../../Universal/API/Context-API/hooks/useUserState";
import ArtButton from "./ArtButton";

export const shadowPropsUnit: ViewStyle = {
  shadowColor: "black",
  shadowOffset: { height: 1 / 2, width: 5 / 3 },
  shadowOpacity: 0.3,
  shadowRadius: 14,
};

export interface UnitProps {
  unit: {
    url: string;
    description: string;
    price: string | number;
    unit: DeanteData;
    discount: number;
    discounted_price: string | number;
  };
  onPress?: () => any;
  fullWidth?: boolean; // <--- добавили
  shouldLoadMedia?: boolean;
}

export const formPrice = ({
  unit,
  isDiscount,
}: {
  unit: UnitProps["unit"];
  isDiscount?: boolean;
}) => {
  const key = isDiscount ? "discounted_price" : "price";
  return (
    <>
      {unit[key] && parseInt(unit[key] + "") > 999997 ? "По запросу" : unit[key]}
    </>
  );
};

export const getWidth_ = ({
  isSmallVersion,
  isMediumVersion,
}: {
  isSmallVersion: boolean;
  isMediumVersion: boolean;
}) => {
  if (isSmallVersion) return "50%";
  if (isMediumVersion) return "33.3%";
  return "25%";
};

const Unit: React.FC<UnitProps> = ({
  unit,
  onPress,
  fullWidth,
  shouldLoadMedia = true,
}) => {
  const { isSmallVersion, isTooSmall, isMediumVersion, scaleAll } =
    useAppContext();
  const [isOnHover, setIsOnHover] = useState(false);
  const [mediaEnabled, setMediaEnabled] = useState(shouldLoadMedia);

  const userState = useUserState();

  const getWidth = () => {
    if (fullWidth) return undefined;
    if (isSmallVersion) return "50%";
    if (isMediumVersion) return "33.3333%";
    return "25%";
  };

  // ✅ middle mouse support for RN Web
  const pressableRef = useRef<any>(null);

  useEffect(() => {
    if (shouldLoadMedia) {
      setMediaEnabled(true);
    }
  }, [shouldLoadMedia]);

  useEffect(() => {
    if (mediaEnabled) return;
    if (Platform.OS !== "web") return;

    const node = pressableRef.current;
    if (!node || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          setMediaEnabled(true);
          observer.disconnect();
          break;
        }
      },
      {
        root: null,
        rootMargin: "300px 0px",
        threshold: 0.01,
      }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [mediaEnabled]);

  useEffect(() => {
    const node = pressableRef.current;

    // На mobile/нативе это не DOM-элемент
    if (!node || typeof node.addEventListener !== "function") return;

    const handler = (e: MouseEvent) => {
      // middle button
      if (e.button === 1) {
        // убрать автоскролл браузера
        e.preventDefault();

        // не ломаем middle click по интерактивным элементам внутри (если вдруг появятся)
        const target = e.target as HTMLElement | null;
        if (target?.closest("a, button, input, textarea, select")) return;

        onPress?.();
      }
    };

    // auxclick — спец. событие для middle click
    node.addEventListener("auxclick", handler);
    // fallback
    node.addEventListener("mousedown", handler);

    return () => {
      node.removeEventListener("auxclick", handler);
      node.removeEventListener("mousedown", handler);
    };
  }, [onPress]);

  const mediaHeight =
    (isSmallVersion ? 120 : isMediumVersion ? 140 : 193) * scaleAll;
  const singleImageHeight =
    (isSmallVersion ? 120 : isMediumVersion ? 140 : 193) * scaleAll;

  return (
    <View
      style={[
        fullWidth ? { flex: 1 } : null,
        getWidth() ? { width: getWidth() } : null,
      ]}
    >
        {unit.unit && unit.unit.art && 
        <View style={[{
            position: 'absolute',
            left: scaleAll * 10,
            
            zIndex: 1000,
        }, 
        // isSmallVersion ? {
            
        //     bottom: scaleAll * 10
        // }: 
        {top:  scaleAll * 10,}]}>
            <ArtButton unit={unit.unit}/>
        </View>
       }
    <Pressable
      ref={pressableRef}
    //   style={{ width: getWidth() }}
      // можно и width={getWidth()}, но на web стабильнее через style
      
      onPress={onPress}
      onHoverIn={() => setIsOnHover(true)}
      onHoverOut={() => setIsOnHover(false)}
    >
      <Box
        bg="white"
        width="100%"
        height={
          isSmallVersion
            ? 220 * scaleAll
            : isMediumVersion
            ? 320 * scaleAll
            : 400 * scaleAll
        }
        px={isSmallVersion ? 2 : isMediumVersion ? 5 : 8}
        py={isSmallVersion ? 3 : isMediumVersion ? 6 : 8}
        borderWidth={0.5}
        borderColor="gray.300"
        style={[isOnHover ? shadowPropsUnit : {}]}
        alignItems="center"
        justifyContent="center"
      >
        <View style={{ width: "100%", overflow: "hidden" }}>
          {mediaEnabled ? (
            unit.unit.sliders.medium.length > 0 ? (
              <View
                style={{
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CarouselImages
                  carouselProps={
                    {
                      loop: true,
                      windowSize: 1,
                      
                    } as TCarouselProps
                  }
                  data={unit.unit.sliders.medium}
                  width={300}
                  height={mediaHeight}
                  addPagination={true}
                  renderItem={({ item }) => {
                    return (
                      <AutoWidthImage
                          source={{
                            uri: item,
                          }}
                          maxWidth={300}
                          scaleAll={scaleAll}
                          height={mediaHeight}
                        />
                    );
                  }}
                />
              </View>
            ) : (
              <AutoWidthImage
                source={{
                  uri: unit.url,
                  priority: "high",
                }}
                scaleAll={scaleAll}
                height={singleImageHeight}
              />
            )
          ) : (
            <View
              style={{
                width: "100%",
                height:
                  unit.unit.sliders.medium.length > 0
                    ? mediaHeight
                    : singleImageHeight,
                backgroundColor: "#f3f4f6",
              }}
            />
          )}
        </View>

        <VStack flex={1} justifyContent="space-between" alignItems="center" mt={4}>
          <Text
            textAlign="center"
            fontFamily={webFont("Inter")}
            fontWeight="600"
            maxWidth={"7/8"}
            fontSize={(isSmallVersion ? 12 : isMediumVersion ? 14 : 16) * scaleAll}
            color="black"
            noOfLines={3}
          >
            {unit.description}
          </Text>

          <Box style={{ width: "100%" }}>
            <Text
              textAlign="center"
              fontFamily={webFont("Inter")}
              fontWeight="600"
              fontSize={
                (isSmallVersion ? 12 : isMediumVersion ? 14 : 16) * scaleAll
              }
              color="black"
              mt={2}
            >
              {formPrice({
                unit,
                isDiscount: userState.isUserLoogedInAndShowDiscountPrices,
              })}
            </Text>
          </Box>
        </VStack>
      </Box>

      <Box
        style={[
          { position: "absolute", zIndex: 1000, right: 10, bottom: 10 },
          isTooSmall && {
            bottom: undefined,
            top: 10,
          },
        ]}
      >
        <OstatkiDisplay
          compact={true}
          unit={unit.unit}
          scaleAll={scaleAll}
          ostatki={unit["unit"]["ostatki"]}
        />
      </Box>
    </Pressable>
    </View>
  );
};

export default React.memo(Unit);
